module.exports = {"420682001":"光化街道","420682002":"酂阳街道","420682100":"孟楼镇","420682101":"竹林桥镇","420682102":"薛集镇","420682103":"张集镇","420682104":"仙人渡镇","420682105":"洪山嘴镇","420682106":"李楼镇","420682200":"袁冲乡","420682501":"蔬菜原种场","420682502":"百花山林场","420682503":"林茂山林场","420682504":"二房营原种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420682.json
// module id = 1744
// module chunks = 0